import { useEffect, useRef } from 'react';

import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ANALYTICS_PREFIX } from '../../common/constants';
import { PageProjectDetailsProps } from '../../common/types';
import { LeftHandSideWrapper } from '../../common/ui/left-hand-side-wrapper/left-hand-side-wrapper';
import { RightHandSideWrapper } from '../../common/ui/right-hand-side-wrapper/right-hand-side-wrapper';
import { useWizardConfiguration } from '../../controllers';

import { LeftHandSidePageProjectDetails } from './left-hand-side/left-hand-side';
import { getDefaultProjectName } from './left-hand-side/utils';
import { RightHandSidePageProjectDetails } from './right-hand-side/right-hand-side';

export const PageProjectDetails = (props: PageProjectDetailsProps) => {
	const { onProjectNameChange, isIllustrationRefresh } = props;
	const {
		teamType,
		projectDetails: { template },
	} = useWizardConfiguration();
	const { formatMessage } = useIntl();
	const resolvedDefaultProjectName =
		props.currentProjectName ??
		getDefaultProjectName(teamType, props.defaultProjectName, formatMessage);

	const { createAnalyticsEvent } = useAnalyticsEvents();

	const hasInitializedRef = useRef<boolean>(false);

	useEffect(() => {
		if (!hasInitializedRef.current && !props.currentProjectName) {
			onProjectNameChange(resolvedDefaultProjectName);
			hasInitializedRef.current = true;
		}
	}, [props.currentProjectName, onProjectNameChange, resolvedDefaultProjectName]);

	useEffect(() => {
		createAnalyticsEvent({
			action: 'viewed',
			eventType: 'screen',
			name: `${ANALYTICS_PREFIX}ProjectDetails`,
			attributes: {
				teamType: teamType,
				template: template,
			},
		}).fire();
	}, [createAnalyticsEvent, template, teamType]);

	return (
		<>
			<LeftHandSideWrapper isIllustrationRefresh={isIllustrationRefresh}>
				<LeftHandSidePageProjectDetails
					{...props}
					defaultProjectName={resolvedDefaultProjectName}
				/>
			</LeftHandSideWrapper>

			<RightHandSideWrapper>
				<RightHandSidePageProjectDetails
					projectName={resolvedDefaultProjectName}
					isIllustrationRefresh={isIllustrationRefresh}
				/>
			</RightHandSideWrapper>
		</>
	);
};
